import React, { useState, useEffect } from 'react'
import { View, Text, Heading, Button, TextField, Flex, Divider} from '@aws-amplify/ui-react';
import Loadingmini from './loadingmini';
import { API, Auth } from 'aws-amplify';
import Searchselect from './searchselect';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { api3Get, api3Post, api3Put } from '../api/api3Client';

export const Reservationcreate = ({fleetCode, vehicles, selectedVehicle, drivers, selectedDriver, refreshParent}) => {
  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const [is_loading, updateIsLoading] = React.useState(false);
  const [displayWindow, updateDisplayWindow] = useState(false);
  const [makePaymentError, updateMakePaymentError] = useState(false);
  const [createResError, updateCreateResError] = useState(false);
  const [showConfirmInfo, updateShowConfirmInfo] = useState(false);
  const [showReservationSelect, updateShowReservationSelect] = useState(false);
  const [resSearchError, updateResSearchError] = useState(false);
  const [loadError, updateLoadError] = useState("");
  const [vehicleList, updateVehicleList] = useState([]);
  const [driverList, updateDriverList] = useState([]);
  const [vehicleId, updateVehicleId] = useState(0);
  const [driverId, updateDriverId] = useState(0);
  const [selectedDriverName, updateSelectedDriverName] = useState("");
  const [selectedVehicleName, updateSelectedVehicleName] = useState("");
  //var now = ;
  //var tomorrow = new Date();
  //tomorrow.setDate(tomorrow.getDate() + 1);
  const [startDate, updateStartDate] = useState(roundBack(new Date(),12));
  const [endDate, updateEndDate] = useState(roundBack(new Date(),16));
  const [resId, updateResId] = useState("");
  const [reservationCreateResponse, updateReservationCreateResponse] = useState({});
  const [driverSearchSelectActive, updateDriverSearchSelectActive] = useState(false);
  const [vehicleSearchSelectActive, updateVehicleSearchSelectActive] = useState(false);
  const [totalCost, updateTotalCost] = useState(false);
  const [credits, updateCredits] = useState(false);
  const [depositOnFile, updateDepositOnFile] = useState(false);
  const [depositRequiredAmount, updateDepositRequiredAmount] = useState(false);
  const [startString, updateStartString] = useState(false);
  const [endString, updateEndString] = useState(false);
  const [timezone, updateTimezone] = useState(false);
  const [driverNameFirst, updateDriverNameFirst] = useState(false);
  const [driverNameLast, updateDriverNameLast] = useState(false);
  const [vehicleName, updateVehicleName] = useState(false);

  const [depositAmount, updateDepositAmount] = useState(0);
  const [invoice, updateInvoice] = useState(false);
  const [showInsuranceStep, updateShowInsuranceStep] = useState(false);
  const [insuranceGate, updateInsuranceGate] = useState(null);
  const [insuranceChoice, updateInsuranceChoice] = useState(null);
  const [selectedProgram, updateSelectedProgram] = useState(null);
  const [caseId, updateCaseId] = useState(null);
  const [checkoutPreview, updateCheckoutPreview] = useState(null);
  const [insuranceMode, updateInsuranceMode] = useState(null);
  const [grandTotalUsd, updateGrandTotalUsd] = useState(null);
  const [cardReady, updateCardReady] = useState(false);
  const [legacyFleetCheckout, updateLegacyFleetCheckout] = useState(false);
  const [cardLast4, updateCardLast4] = useState(null);
  const [cardMessage, updateCardMessage] = useState("");
  const [createdVehicleId, updateCreatedVehicleId] = useState(0);
  const prefetchInFlightRef = React.useRef(false);
  const prefetchDoneRef = React.useRef(false);

  function apiErrorMessage(e) {
    if (!e) return "Request failed";
    return e.data?.message || e.message || String(e);
  }

  function formatDateTime(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  function resetCheckoutState() {
    updateShowInsuranceStep(false);
    updateInsuranceGate(null);
    updateInsuranceChoice(null);
    updateSelectedProgram(null);
    updateCaseId(null);
    updateCheckoutPreview(null);
    updateInsuranceMode(null);
    updateGrandTotalUsd(null);
    updateCardReady(false);
    updateLegacyFleetCheckout(false);
    updateCardLast4(null);
    updateCardMessage("");
    updateDepositAmount(0);
    updateInvoice(false);
    updateShowConfirmInfo(false);
  }

  useEffect(() => {
    prefetchDoneRef.current = false;
    updateDriverList([]);
    updateVehicleList([]);
    updateLoadError("");
    updateDisplayWindow(false);
  }, [fleetCode]);

  function failPrefetch(message) {
    updateLoadError(message);
    updateDriverList([]);
    updateVehicleList([]);
    prefetchInFlightRef.current = false;
    updateIsLoading(false);
  }

  async function fetchAgoItems(apiEndpoint) {
    let session = await Auth.currentSession();
    let jwt = session.getAccessToken().getJwtToken();
    try {
      const res = await API.get('adminWebTools', '/ago', {queryStringParameters: {
        back_end: process.env.REACT_APP_BACKEND,
        jwt: jwt,
        api_endpoint: apiEndpoint,
        request_type: 'GET',
        fleet_code: fleetCode,
      }});
      if (!res || !Array.isArray(res.items)) {
        return {ok: false, error: 'Unexpected list response', items: []};
      }
      return {ok: true, items: res.items};
    } catch (e) {
      return {ok: false, error: String(e && e.message ? e.message : e), items: []};
    }
  }

  async function fetchDriverList() {
    return fetchAgoItems('api3:portal:driver_picker');
  }

  async function fetchVehicleList() {
    return fetchAgoItems('api3:portal:vehicle_picker');
  }

  async function fetchData() {
    if (prefetchInFlightRef.current) {
      return;
    }
    prefetchInFlightRef.current = true;
    updateIsLoading(true)
    updateLoadError("");
    if(selectedDriver)
    {
      if(selectedDriver > 0)
      {
        updateDriverId(selectedDriver)
      }
    }
    if(selectedVehicle)
    {
      if(selectedVehicle > 0)
      {
        updateVehicleId(selectedVehicle)
      }
    }

    const hasDrivers = typeof(drivers) !== 'undefined' && typeof(drivers[0]) !== 'undefined';
    const hasVehicles = typeof(vehicles) !== 'undefined' && typeof(vehicles[0]) !== 'undefined';

    try {
      if (!hasDrivers && !hasVehicles) {
        const [driverResult, vehicleResult] = await Promise.all([
          fetchDriverList(),
          fetchVehicleList(),
        ]);
        if (!driverResult.ok) {
          failPrefetch(driverResult.error);
          return;
        }
        if (!vehicleResult.ok) {
          failPrefetch(vehicleResult.error);
          return;
        }
        updateDriverList(driverResult.items);
        updateVehicleList(vehicleResult.items);
      } else {
        if (!hasDrivers) {
          const driverResult = await fetchDriverList();
          if (!driverResult.ok) {
            failPrefetch(driverResult.error);
            return;
          }
          updateDriverList(driverResult.items);
        } else {
          updateDriverList(drivers);
        }

        if (!hasVehicles) {
          const vehicleResult = await fetchVehicleList();
          if (!vehicleResult.ok) {
            failPrefetch(vehicleResult.error);
            return;
          }
          updateVehicleList(vehicleResult.items);
        } else {
          updateVehicleList(vehicles);
        }
      }
      prefetchDoneRef.current = true;
    } finally {
      prefetchInFlightRef.current = false;
      updateIsLoading(false);
    }
  }
  async function openCreateWindow() {
    if (prefetchInFlightRef.current) {
      return;
    }
    const needsPrefetch = !prefetchDoneRef.current && (
      !Array.isArray(driverList) || driverList.length === 0 ||
      !Array.isArray(vehicleList) || vehicleList.length === 0
    );
    if (needsPrefetch) {
      await fetchData();
    }
    updateDisplayWindow(true);
  }

  async function retryPrefetch() {
    prefetchDoneRef.current = false;
    updateLoadError("");
    await fetchData();
  }


  async function reservationSearch() {
    if(driverId > 0)
    {
        var session = await Auth.currentSession()
        var accessToken = session.getAccessToken()
        var jwt = accessToken.getJwtToken()
        var myInit = {queryStringParameters:{
            "back_end": process.env.REACT_APP_BACKEND,
            "jwt":jwt,
            "api_endpoint":"api3:portal:driver_address",
            "request_type":"GET",
            "fleet_code":fleetCode,
            "driver_id":driverId
        }};
        try{
          const res = await API.get('adminWebTools','/ago',myInit);
          var driverLat = res['latitude'];
          var driverLng = res['longitude'];
        }
        catch (e) {
            console.log(toString(e));
        }
        // Get date components
        var year = startDate.getFullYear();
        var month = String(startDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        var day = String(startDate.getDate()).padStart(2, '0');

        // Get time components
        var hours = String(startDate.getHours()).padStart(2, '0');
        var minutes = String(startDate.getMinutes()).padStart(2, '0');

        // Format the string
        var startString = `${year}-${month}-${day} ${hours}:${minutes}`;
        
        // Get date components
        year = endDate.getFullYear();
        month = String(endDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        day = String(endDate.getDate()).padStart(2, '0');

        // Get time components
        hours = String(endDate.getHours()).padStart(2, '0');
        minutes = String(endDate.getMinutes()).padStart(2, '0');

        // Format the string
        var endString = `${year}-${month}-${day} ${hours}:${minutes}`;

        updateIsLoading(true)
        updateResSearchError(false)
        updateCreateResError(false)
        updateMakePaymentError(false)


        try {
            const res = await api3Get('/reservations/availability', {
              fleet_code: fleetCode,
              intent: 'no',
              driver_id: driverId,
              car_id: vehicleId > 0 ? vehicleId : undefined,
              res_start: startString,
              res_end: endString,
              window_days: 30,
              max_dist: 100,
              driver_lat: driverLat,
              driver_lon: driverLng,
            });
            console.log('res: ' + JSON.stringify(res))
            if (res && res.status && res.status !== 'success') {
              updateResSearchError(res.detail || res.message || JSON.stringify(res))
            } else if (res && 'detail' in res) {
              updateResSearchError(res.detail)
            }
            // TO DO update the list of reservations to select from
        }
        catch (e) {
            console.log('reservation search error: ' + apiErrorMessage(e));
            updateResSearchError(apiErrorMessage(e))
        }
        updateIsLoading(false)
    } else {
      updateResSearchError("driver, start, and end must be selected.")
    }
  }


  const cancelReservation = async () => {
    if (!resId) {
      return;
    }
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{ 
      back_end: process.env.REACT_APP_BACKEND,
      jwt: jwt,
      api_endpoint: "api3:reservations:cancel",
      request_type: "POST",
      res_id: resId,
      mode: "cancel",
      started: true,
      full_refund: true,
      cash_refund: true,
      reason: "Support create cancel"
    }};
    try {
      await API.get('adminWebTools','/ago',myInit)
    } catch (e) {
      var error = "Error computing cancel for reservation: " + JSON.stringify(e)
      console.log(error)
    }
    updateIsLoading(false);
  }

  function applySavedCard(preview) {
    const onConnect = Boolean(preview?.connectReady);
    const legacyFleet = !onConnect && preview?.savedPaymentMethodMessage === "Fleet is not on Connect checkout";
    const ready = Boolean(onConnect && preview?.hasDefaultPaymentMethod);
    updateCardReady(ready);
    updateLegacyFleetCheckout(legacyFleet);
    updateCardLast4(preview?.defaultPaymentMethodLast4 || null);
    updateCardMessage(
      ready || legacyFleet
        ? ""
        : (preview?.savedPaymentMethodMessage || "No saved Connect card for this driver. They must save a card in the app first.")
    );
    return ready || legacyFleet;
  }

  async function loadDepositPreview(thisDriverId, thisVehicleId) {
    const deposit = await api3Post('/drivers/deposit/checkout', {
      fleetCode,
      driverId: Number(thisDriverId),
      vehicleId: Number(thisVehicleId),
      mode: 'compute',
    });
    const incremental = Number(deposit?.incrementalDeposit || 0);
    updateDepositAmount(incremental > 0 && deposit?.actionRequired ? incremental : 0);
    updateDepositOnFile(deposit?.amountOnDeposit || 0);
    updateDepositRequiredAmount(deposit?.totalDeposit || 0);
    return deposit;
  }

  async function computeCheckout(reservationId, mode, thisCaseId) {
    const body = {
      insuranceMode: mode,
      mode: 'compute',
    };
    if (mode === 'purchasing' && thisCaseId) {
      body.caseId = thisCaseId;
    }
    const preview = await api3Post(
      `/reservations/${encodeURIComponent(reservationId)}/checkout/combined`,
      body
    );
    updateCheckoutPreview(preview);
    updateInvoice(preview?.rental?.invoice || false);
    updateGrandTotalUsd(preview?.grandTotalUsd);
    updateInsuranceMode(mode);
    applySavedCard(preview);
    return preview;
  }

  function insuranceOptions(gate) {
    const offering = gate?.insuranceOffering || {};
    const fleetProvides = Boolean(offering.fleetProvidesCoverage);
    const allowPurchase = Boolean(offering.allowPurchase);
    const personalApproved = Boolean(gate?.personalInsuranceApproved);
    const allowPersonalChoice = Boolean(offering.allowPersonal) && personalApproved;
    return { offering, fleetProvides, allowPurchase, personalApproved, allowPersonalChoice };
  }

  async function afterCreate(reservationId, thisDriverId, thisVehicleId) {
    const [gate, deposit] = await Promise.all([
      api3Get(`/reservations/${encodeURIComponent(reservationId)}/insurance`),
      loadDepositPreview(thisDriverId, thisVehicleId),
    ]);
    updateInsuranceGate(gate);
    const opts = insuranceOptions(gate);
    if (Number(deposit?.incrementalDeposit || 0) > 0) {
      applySavedCard(deposit);
    }
    if (opts.fleetProvides) {
      await computeCheckout(reservationId, 'personal', null);
      updateShowConfirmInfo(true);
      return;
    }
    if (!opts.allowPurchase && !opts.allowPersonalChoice) {
      if (opts.offering.allowPersonal && !opts.personalApproved) {
        throw new Error("Personal insurance is not approved for this driver. They must upload it in the app first. Purchase insurance is not offered for this fleet.");
      }
      throw new Error("This fleet has no bookable insurance path for this driver.");
    }
    if (opts.allowPersonalChoice && !opts.allowPurchase) {
      updateInsuranceChoice('personal');
    }
    updateShowInsuranceStep(true);
  }

  async function continueInsurance() {
    if (!resId) {
      return;
    }
    updateIsLoading(true);
    updateCreateResError(false);
    updateMakePaymentError(false);
    try {
      const gate = insuranceGate || {};
      const fleetId = gate.fleetId;
      const thisDriverId = gate.driverId || driverId;
      if (insuranceChoice === 'personal') {
        if (!gate.personalInsuranceApproved) {
          throw new Error("Personal insurance is not approved for this driver.");
        }
        await api3Put(`/parties/${thisDriverId}/fleets/${fleetId}/insurance-preference`, {
          path: 'personal',
        });
        await computeCheckout(resId, 'personal', null);
        updateShowInsuranceStep(false);
        updateShowConfirmInfo(true);
        return;
      }
      const program = selectedProgram;
      if (!program?.programMasterId || !program?.variantId) {
        throw new Error("Select an insurance program.");
      }
      await api3Put(`/parties/${thisDriverId}/fleets/${fleetId}/insurance-preference`, {
        path: 'ago',
        programMasterId: program.programMasterId,
        variantId: program.variantId,
      });
      const bound = await api3Post(
        `/reservations/${encodeURIComponent(resId)}/insurance/bind`,
        {
          programMasterId: program.programMasterId,
          variantId: program.variantId,
          mode: 'compute',
        }
      );
      const boundCaseId = bound?.caseId;
      if (!boundCaseId) {
        throw new Error(bound?.message || "Insurance bind did not return a case.");
      }
      updateCaseId(boundCaseId);
      await api3Post(`/insurance/cases/${boundCaseId}/terms-acknowledgement`, {});
      await computeCheckout(resId, 'purchasing', boundCaseId);
      updateShowInsuranceStep(false);
      updateShowConfirmInfo(true);
    } catch (e) {
      updateCreateResError(apiErrorMessage(e));
    } finally {
      updateIsLoading(false);
    }
  }

  async function createReservation() {
    if(vehicleId > 0 && driverId > 0)
    {
        const startStr = formatDateTime(startDate);
        const endStr = formatDateTime(endDate);

        updateIsLoading(true)
        updateCreateResError(false)
        updateMakePaymentError(false)
        updateResSearchError(false)
        resetCheckoutState();
        try {
            const res = await api3Post('/reservations', {
              fleetCode,
              renterId: Number(driverId),
              assetId: Number(vehicleId),
              startString: startStr,
              endString: endStr,
              overrideStart: true,
              overrideEnd: true,
              intent: 'no',
            });
            console.log('create reservation response: ' + JSON.stringify(res))
            updateReservationCreateResponse(res);
            const newResId = res?.res_id || res?.resId;
            if(!newResId)
            {
              updateCreateResError(res?.message || res?.detail || JSON.stringify(res))
              updateIsLoading(false)
              return;
            }
            updateResId(newResId);
            updateTotalCost(res?.prices?.price_total);
            updateCredits(res?.prices?.credits);
            updateDepositOnFile(res?.prices?.deposit);
            updateDepositRequiredAmount(res?.prices?.deposit_total);
            updateStartString(res?.reservation?.start_string);
            updateEndString(res?.reservation?.end_string);
            updateTimezone(res?.reservation?.timezone);
            updateDriverNameFirst(res?.driver?.name_first);
            updateDriverNameLast(res?.driver?.name_last);
            updateVehicleName(res?.car?.name);
            const thisVehicleId = res?.car?.car_id || vehicleId;
            const thisDriverId = res?.driver?.user_id || driverId;
            updateCreatedVehicleId(thisVehicleId);
            await afterCreate(newResId, thisDriverId, thisVehicleId);
            updateIsLoading(false);
        }
        catch (e) {
            console.log('create reservation error: '+apiErrorMessage(e));
            updateCreateResError(apiErrorMessage(e))
            updateIsLoading(false)
        }
    } else {
      updateCreateResError("Vehicle, driver, start, and end must be selected.")
      updateIsLoading(false)
    }
  }

  async function makePayment() {
    if(resId==="")
    {
      return;
    }
    if (!cardReady && !legacyFleetCheckout) {
      updateMakePaymentError(cardMessage || "No saved Connect card for this driver.");
      return;
    }
    updateIsLoading(true)
    updateCreateResError(false)
    updateMakePaymentError(false)
    updateResSearchError(false)
    try {
      if (Number(depositAmount) > 0) {
        await api3Post('/drivers/deposit/checkout', {
          fleetCode,
          driverId: Number(driverId),
          vehicleId: Number(createdVehicleId || vehicleId),
          mode: 'payment',
        });
      }
      const payBody = {
        insuranceMode: insuranceMode || 'personal',
        mode: 'payment',
      };
      if ((insuranceMode || 'personal') === 'purchasing' && caseId) {
        payBody.caseId = caseId;
      }
      const res = await api3Post(
        `/reservations/${encodeURIComponent(resId)}/checkout/combined`,
        payBody
      );
      if (res?.status === 'success') {
        resetCheckoutState();
        refreshParent();
      } else {
        updateMakePaymentError(res?.message || res?.status || "Payment failed");
      }
    } catch (e) {
      updateMakePaymentError(apiErrorMessage(e));
    }
    updateIsLoading(false)
  }

  async function handleupdateVehicleSearchSelectActive(val) {
    updateVehicleSearchSelectActive(val);
    if(val)
    {
      updateDriverSearchSelectActive(false);
    }
  }

  async function handleupdateDriverSearchSelectActive(val) {
    updateDriverSearchSelectActive(val);
    if(val)
    {
      updateVehicleSearchSelectActive(false);
    }
  }


  async function closeWindow() {
    updateCreateResError(false)
    updateMakePaymentError(false)
    updateResSearchError(false)
    updateLoadError("")
    resetCheckoutState();
    updateDisplayWindow(false)
  }

  async function cancelMadeReservation() {
    cancelReservation()
    resetCheckoutState();
  }

  return (<View style={{flex:1}}>
    {
      is_loading ? <Loadingmini /> : 
      displayWindow ? 
        <View>
          <Heading level={4}>New Reservation</Heading>
          <Text>Complete the form below to create a reservation on behalf of a driver.</Text>
          {loadError ? (
            <View>
              <Text color="red">{loadError}</Text>
              <Button onClick={() => retryPrefetch()}>RETRY LOAD</Button>
            </View>
          ) : null}
          <br/>
          {
            showInsuranceStep ? (
              <View>
                <Heading level={4}>Insurance</Heading>
                <Text>Choose coverage the same way the app does. Personal insurance is only available when this driver is already approved.</Text>
                <br/>
                {insuranceOptions(insuranceGate).offering.allowPersonal && !insuranceOptions(insuranceGate).personalApproved ? (
                  <Text><i>Personal insurance is not approved for this driver. They must upload it in the app first.</i></Text>
                ) : null}
                {insuranceOptions(insuranceGate).allowPersonalChoice ? (
                  <View>
                    <br/>
                    <Button
                      variation={insuranceChoice === 'personal' ? 'primary' : undefined}
                      onClick={() => { updateInsuranceChoice('personal'); updateSelectedProgram(null); }}
                    >
                      Use approved personal insurance
                    </Button>
                  </View>
                ) : null}
                {insuranceOptions(insuranceGate).allowPurchase ? (
                  <View>
                    <br/>
                    <Text><b>Purchase insurance</b></Text>
                    {(insuranceGate?.programs || []).length === 0 ? (
                      <Text>No insurance programs available for this vehicle/window.</Text>
                    ) : (insuranceGate.programs || []).map((program) => {
                      const key = `${program.programMasterId}-${program.variantId}`;
                      const selected = selectedProgram && selectedProgram.programMasterId === program.programMasterId && selectedProgram.variantId === program.variantId;
                      const price = program?.pricing?.totalUsd ?? program?.pricing?.premiumUsd;
                      return (
                        <View key={key} marginBottom="0.5rem">
                          <Button
                            variation={selected ? 'primary' : undefined}
                            onClick={() => { updateInsuranceChoice('purchase'); updateSelectedProgram(program); }}
                          >
                            {program.displayName || program.variantCode || key}{price != null ? ` — $${Number(price).toFixed(2)}` : ''}
                          </Button>
                        </View>
                      );
                    })}
                  </View>
                ) : null}
                {createResError ? (
                  <View>
                    <br/>
                    <Text color="red"><b>{createResError}</b></Text>
                  </View>
                ) : null}
                <br/>
                <Button
                  onClick={() => continueInsurance()}
                  isDisabled={insuranceChoice !== 'personal' && !selectedProgram}
                >
                  CONTINUE
                </Button>
                <br/>
                <br/>
                <Button onClick={() => cancelMadeReservation()}>
                    CANCEL
                </Button>
              </View>
            ) : showConfirmInfo === false ?
              <View>
                <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                  <Text>Driver:</Text>
                  {vehicleSearchSelectActive ? <Text>Select a vehicle first</Text> : <Searchselect searchType="driver" objects={driverList} selectObject={updateDriverId} selectedObject={driverId} updateSelectedObjectName={updateSelectedDriverName} selectedObjectName={selectedDriverName} updateSearchSelectActive={handleupdateDriverSearchSelectActive}/> }
                </Flex>
                <br/>
                <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                  <Text>Vehicle:</Text>
                  {driverSearchSelectActive ? <Text>Select a driver first</Text> : <Searchselect searchType="vehicle" objects={vehicleList} selectObject={updateVehicleId} selectedObject={vehicleId} updateSelectedObjectName={updateSelectedVehicleName} selectedObjectName={selectedVehicleName} updateSearchSelectActive={handleupdateVehicleSearchSelectActive}/> }
                </Flex>
                <br/>
                <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                  <Text>Start:</Text>
                  <DatePicker
                        name="Start Date"
                        selected={startDate}
                        onChange={(date) => updateStartDate(date)}
                        showTimeSelect
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeIntervals={60}
                      />
                </Flex>
                <br/>
                <br/>
                <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                  <Text>End:</Text>
                  <DatePicker
                        name="End Date"
                        selected={endDate}
                        onChange={(date) => updateEndDate(date)}
                        showTimeSelect
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeIntervals={60}
                      />
                </Flex>
                <br />
                <br/>
                {
                  createResError === false ? 
                    undefined 
                  :
                    <View>
                      <Heading level={4}>Error</Heading>
                      <Text>There was an issue creating your reservation.</Text> 
                      <Text>Please double-check the vehicle, driver, start, and end, and try again.</Text>
                      <Text><b><i>{createResError}</i></b></Text>
                      {resId ? (
                        <Button onClick={() => cancelMadeReservation()}>CANCEL RESERVATION</Button>
                      ) : null}
                    </View>
                }
                {
                  createResError ? 
                  <Button onClick={() => createReservation()}>
                      TRY AGAIN
                  </Button>
                  :
                  <Button onClick={() => createReservation()}>
                      CREATE RESERVATION
                  </Button>
                }
                <br />
                <br />
                <Button onClick={() => closeWindow()}>
                    CANCEL
                </Button>
              </View>
            :
              makePaymentError ? 
                <View>
                  <Heading level={4}>Error Paying for Reservation</Heading>
                  <Text>{String(makePaymentError)}</Text>
                  <br />
                  <br />
                  <Button onClick={() => updateMakePaymentError(false)}>
                      TRY AGAIN
                  </Button>
                  <br />
                  <br />
                  <Button onClick={() => cancelMadeReservation()}>
                      CANCEL
                  </Button>
                </View>
              :
                <View>
                  <Heading level={4}>Complete Payment</Heading>
                  {
                    depositAmount > 0 ?
                      <Text><i>Deposit of ${Number(depositAmount).toFixed(2)} will be charged on the saved Connect card, in addition to rental{insuranceMode === 'purchasing' ? ' and insurance' : ''}.</i></Text>
                    :
                      <Text><i>No deposit required at this time.</i></Text>
                  }
                  
                  <br/>
                  <Text>New Reservation ID:  {resId}</Text>
                  <Text>Driver:  {driverNameFirst} {driverNameLast}</Text>
                  <Text>Vehicle:  {vehicleName}</Text>
                  <Text>Timezone:  {timezone}</Text>
                  <Text>Start:  {startString}</Text>
                  <Text>End:  {endString}</Text>
                  <Text>Insurance:  {insuranceMode === 'purchasing' ? 'Purchase' : 'Personal / fleet coverage'}</Text>
                  {legacyFleetCheckout ? (
                    <Text>This fleet bills on its own Stripe account. Pay charges the driver's saved card there.</Text>
                  ) : cardReady ? (
                    <Text>Saved Connect card{cardLast4 ? ` ending ${cardLast4}` : ''} will be charged. Old Stripe invoices are not used.</Text>
                  ) : (
                    <Text color="red"><b>{cardMessage || "No saved Connect card for this driver."}</b></Text>
                  )}
                  {credits ? <Text>Credits:  ${credits}</Text> : null}
                  <Text><b>Rental total:  ${totalCost}</b></Text>
                  {checkoutPreview?.insurance?.totalUsd != null ? (
                    <Text><b>Insurance total:  ${Number(checkoutPreview.insurance.totalUsd).toFixed(2)}</b></Text>
                  ) : null}
                  {grandTotalUsd != null ? (
                    <Text><b>Grand total:  ${Number(grandTotalUsd).toFixed(2)}</b></Text>
                  ) : null}
                  {depositAmount > 0 ? (
                    <Text><b>Deposit due now:  ${Number(depositAmount).toFixed(2)}</b></Text>
                  ) : null}
                  
                  <Divider marginTop="1rem" marginBottom="1rem" />
                  <Text><b>Itemized Invoice:</b></Text>
                  {
                    (!invoice || 
                      !(
                        (typeof invoice['total'] === 'number') || 
                        (typeof invoice['total'] === 'string' && invoice['total'].trim().length > 0)
                      )
                    ) ? (
                      <Text>Loading invoice...</Text>
                    ) : (
                      <View>
                        {invoice['items'] && invoice['items'].map(([label, amount], index) => (
                          <Flex key={index} direction="row" justifyContent="space-between" alignItems="center" marginBottom="0.25rem">
                            <Text>{label}</Text>
                            <Text>${amount.toFixed(2)}</Text>
                          </Flex>
                        ))}

                        <Divider marginTop="1rem" marginBottom="1rem" />

                        {Math.abs(invoice['credits_used']) > 0 && (
                          <Text>Credits Remaining: ${invoice['credits_remaining'].toFixed(2)}</Text>
                        )}

                        <Text>Sub Total: ${invoice['sub_total'].toFixed(2)}</Text>
                        <Text>Taxes: ${invoice['sub_total_taxes'].toFixed(2)}</Text>
                        <Text><b>Total: ${invoice['total'].toFixed(2)}</b></Text>
                      </View>
                    )
                  }

                  <br />
                  {
                    (cardReady || legacyFleetCheckout) ? (
                      <Button onClick={() => makePayment()}>
                          PAY FOR RESERVATION
                      </Button>
                    ) : (
                      <Text><i>Payment is blocked until this driver has a saved Connect card.</i></Text>
                    )
                  }
                  <br />
                  <br />
                  <Button onClick={() => cancelMadeReservation()}>
                      CANCEL
                  </Button>
                </View>
          }
          <br/>
          <Divider />
        </View>
      :
        <Flex flexDirection='row' justifyContent='flex-end' alignItems='flex-end' alignContent='flex-end' gap='1em'>
          <Button onClick={() => openCreateWindow()}>
            CREATE RESERVATION
          </Button>
        </Flex>
    }
  </View>);
};

export default Reservationcreate;